'use client';

import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress, MenuItem } from '@mui/material';
import { useLazyQuery } from '@parkchirp/api-client';
import React, { useState } from 'react';

import { SetShowSnackbar } from '../../types';

interface CsvExportButtonV2Props {
	query: any;
	queryName: string;
	args: any;
	disabled?: boolean;
	buttonText?: string;
	setShowSnackbar?: SetShowSnackbar;
	menuItem?: boolean;
	onClick?: () => void;
	onComplete?: () => void;
	errorMessage?: string;
}

export const CsvExportButtonV2 = ({
	query,
	queryName,
	args,
	disabled = false,
	buttonText = 'Export',
	setShowSnackbar,
	menuItem = false,
	onClick,
	onComplete,
	errorMessage,
}: CsvExportButtonV2Props): React.JSX.Element => {
	const [downloadInitiated, setDownloadInitiated] = useState<boolean>(false);
	const [downloadCSV] = useLazyQuery(query);

	const handleDownload = () => {
		onClick?.();
		setDownloadInitiated(true);
		downloadCSV({
			...args,
			context: {
				appName: process.env.NEXT_PUBLIC_APP_NAME,
				...args.context,
			},
			fetchPolicy: 'network-only',
			onCompleted: (response) => {
				setDownloadInitiated(false);
				onComplete?.();
				window.open(response[queryName].url);
			},
			onError: (err) => {
				if (setShowSnackbar) {
					setShowSnackbar({
						message: errorMessage ?? err.message,
						severity: 'error',
					});
				}
				setDownloadInitiated(false);
				onComplete?.();
			},
		});
	};

	return menuItem ? (
		<MenuItem onClick={handleDownload} disabled={disabled}>
			<span style={{ marginRight: '5px' }}>{buttonText}</span>
			{downloadInitiated && <CircularProgress style={{ height: '20px', width: '20px' }} />}
		</MenuItem>
	) : (
		<Button size='small' startIcon={<DownloadIcon />} onClick={handleDownload} disabled={disabled}>
			<span style={{ marginRight: '5px' }}>{buttonText}</span>
			{downloadInitiated && <CircularProgress style={{ height: '20px', width: '20px' }} />}
		</Button>
	);
};
